import { ScrollArea, Table } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { t } from 'i18next';
import { useMemo } from 'react';
import { usePitchUploaderStore } from 'stores/use-pitch-uploader-store';

export const PitchUploaderErrorTab = () => {
  const balls = usePitchUploaderStore((s) => s.balls);

  const invalidBalls = useMemo(
    () => balls.filter((m) => !!m.fatalError),
    [balls]
  );

  return (
    <ErrorBoundary identifier="PitchUploaderErrorTab">
      <ScrollArea style={{ maxHeight: '400px' }} scrollbars="both">
        <Table.Root>
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeaderCell>
                {t('common.name')}
              </Table.ColumnHeaderCell>
              <Table.ColumnHeaderCell>
                {t('common.error')}
              </Table.ColumnHeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {invalidBalls.map((data) => (
              <Table.Row key={data._id}>
                <Table.Cell>{data.details.name}</Table.Cell>
                <Table.Cell>{data.fatalError}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </ScrollArea>
    </ErrorBoundary>
  );
};
